import React from 'react'
import Classnames from 'classnames'
import PropTypes from 'prop-types'
import {
  SupplierScoreMeterRiskStyle, //
} from './styled'
import { Image } from '..'
import { ICONS } from '../../themes'
import ReactTooltip from 'react-tooltip'
export class SupplierScoreMeterRisk extends React.PureComponent {
  // renderScaleIcon = (maxValue, value) => {
  //   if ((maxValue === 4 || maxValue === 5) && 1 <= value <= 5)
  //     return ICONS['icon-score-' + value + '-scale-' + maxValue + '.svg']
  //   else if (value === 'disabled') return ICONS['icon-score-scale-gray.svg']
  //   else return ICONS['icon-score-scale.svg']
  // }
  renderScaleIcon = (maxValue, value) => {
    if ((maxValue === 4 || maxValue === 5) && value <= 1)
      return ICONS['icon-score-' + 1 + '-scale-' + maxValue + '.svg']
    if ((maxValue === 4 || maxValue === 5) && value <= 2)
      return ICONS['icon-score-' + 2 + '-scale-' + maxValue + '.svg']
    if ((maxValue === 4 || maxValue === 5) && value <= 2.4)
      return ICONS['icon-score-' + 3 + '-scale-' + maxValue + '.svg']
    if ((maxValue === 4 || maxValue === 5) && value <= 2.8)
      return ICONS['icon-score-' + 4 + '-scale-' + maxValue + '.svg']
    if ((maxValue === 4 || maxValue === 5) && value > 2.8)
      return ICONS['icon-score-' + 5 + '-scale-' + maxValue + '.svg']
    else if (value === 'disabled') return ICONS['icon-score-scale-gray.svg']
    else return ICONS['icon-score-scale.svg']
  }

  render() {
    const {
      className, //
      maxValue,
      value,
      alt,
      name,
      useTootipFor,
      useTootip,
    } = this.props

    return (
      <SupplierScoreMeterRiskStyle
        className={Classnames(
          'supplier-score-meter', //
          { 'is-disabled': value === 'disabled' },
          className
        )}
        title={!useTootip}
        data-tip={useTootip}
        data-for={useTootipFor}
      >
        <Image src={this.renderScaleIcon(maxValue, value)} alt={alt} />
        <div className="score-name">{name}</div>
        {useTootip && (
          <ReactTooltip id={useTootipFor} place="top" effect="solid">
            {value}
          </ReactTooltip>
        )}
      </SupplierScoreMeterRiskStyle>
    )
  }

  static defaultProps = {
    alt: 'supplier score meter',
    useTootip: false,
  }

  static propTypes = {
    className: PropTypes.string,
    useTootipFor: PropTypes.string,
    useTootip: PropTypes.bool,
  }
}
